import {Component, OnInit} from '@angular/core';
import {JhiLanguageService} from 'ng-jhipster';

@Component({
    selector: 'jhi-error',
    templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
    errorMessage: string;
    error403: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService
    ) {
        this.jhiLanguageService.setLocations(['global']);
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/error/error.component.ts